angular.module('Itao.IndicatorMap').directive('indicatorSetRadioGroup', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorSetRadioGroup.html',
    restrict: 'E',
    scope: {
      indicatorSets: '=',
      selectedIndicatorSet: '=',
      onIndicatorSetSelect: '&',
      deselectAllIndicators: '&'
    },
    link: function (scope) {
      scope.openDropdown = function () {
        jQuery('#indicatorDropdown').closest('.dropdown').toggleClass('open');
      };

      scope.selectIndicatorSet = function (indicatorSet) {
        if(!indicatorSet) return;
        scope.deselectAllIndicators();
        scope.onIndicatorSetSelect({indicatorSet: indicatorSet});
      };
    }
  };
});
